import { defineMessages } from 'react-intl';

export default defineMessages({
  goodResponseLabel: {
    id: 'frontbucket.repository.codeReviewerFeedback.goodResponseLabel',
    description:
      'Label shown on Code Reviewer comment for the good response icon.',
    defaultMessage: 'Helpful',
  },
  badResponseLabel: {
    id: 'frontbucket.repository.codeReviewerFeedback.badResponseLabel',
    description:
      'Label shown on Code Reviewer comment for the bad response icon.',
    defaultMessage: 'Not helpful',
  },
  textAreaLabel: {
    id: 'frontbucket.repository.codeReviewerFeedback.textAreaLabel',
    description:
      'Label shown on text-area for collecting info from Bad Code Reviewer responses',
    defaultMessage: 'Can you describe why this answer was unhelpful?',
  },
  thankYouMessage: {
    id: 'frontbucket.repository.codeReviewerFeedback.thankYouMessage',
    description:
      'Message shown after clicking a thumbs up / down on an Code Reviewer comment',
    defaultMessage: 'Thanks for your feedback!',
  },
  requestcodeReviewerRating: {
    id: 'frontbucket.repository.codeReviewerFeedback.requestCodeReviewerRating',
    description:
      'Text that appears underneath an Code Reviewer comment asking for rating',
    defaultMessage: '{boldText} {normalText}',
  },
  howDidCodeReviewerDoMessage: {
    id: 'frontbucket.repository.codeReviewerFeedback.howDidCodeReviewerDoMessage',
    description:
      'Bold text that appears underneath an Code Reviewer comment asking for feedback',
    defaultMessage: 'How did Code Reviewer do?',
  },
  rateCodeReviewerCommentMessage: {
    id: 'frontbucket.repository.codeReviewerFeedback.rateCodeReviewerCommentMessage',
    description: 'Text that appears next the bold text asking for feedback',
    defaultMessage: 'Rate this comment.',
  },
  aiUsageDisclaimer: {
    id: 'frontbucket.repository.codeReviewerFeedback.aiUsageDisclaimer',
    description: 'Appears in the footer on Code Reviewer comments',
    defaultMessage: 'Uses AI. Verify results.',
  },
  beta: {
    id: 'frontbucket.repository.codeReviewerFeedback.beta',
    description: 'Text for beta lozenge indicating this is Beta functionality',
    defaultMessage: 'Beta',
  },
});
